module.exports = __webpack_public_path__ + "img/juneng.c0b142ab.png";